<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers.filter(a=>a.show || a.active)"
              :items="items"
              :footer-props="datatable_footer"
              :server-items-length="total"
              :options.sync="table_options"
              :loading="loading"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:top>
                <v-card flat>
                  <v-card-text>
                    <v-row dense>
                      <v-col
                        cols="12"
                        sm="2"
                      >
                        <v-text-field
                          v-model="form.search"
                          clearable
                          outlined
                          label="Поиск"
                          prepend-inner-icon="mdi-magnify"
                          dense
                          @keyup.enter="onLoad"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        md="2"
                      >
                        <v-btn
                          color="primary"
                          outlined
                          @click="onShowFilterDialog"
                        >
                          <v-icon class="ml-3">
                            mdi-filter-variant
                          </v-icon>
                          <span class="mx-3">ФИЛЬТРЫ</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        md="2"
                        offset-md="1"
                        offset-xl="4"
                        xl="1"
                      >
                        <v-btn
                          v-if="$store.state.access[15][5]"
                          color="primary"

                          @click="$router.push('/client/nomenclature/create')"
                        >
                          <v-icon class="ml-3">
                            mdi-plus
                          </v-icon>
                          <span class="mx-3">Добавить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        md="2"
                        xl="1"
                      >
                        <v-btn
                          v-if="$store.state.access[15][5]"
                          color="secondary"
                          outlined
                          @click="onReport"
                        >
                          <v-icon class="ml-3">
                            mdi-download
                          </v-icon>
                          <span class="mx-3">Выгрузить</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="3"
                        class="d-sm-flex justify-end"
                        md="2"
                        xl="1"
                      >
                        <v-btn
                          v-if="$store.state.access[15][5]"
                          color="secondary"
                          outlined
                          @click="onImport"
                        >
                          <v-icon class="ml-3">
                            mdi-upload
                          </v-icon>
                          <span class="mx-3">Импорт</span>
                        </v-btn>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="1"
                        class="d-sm-flex justify-center"
                      >
                        <v-icon
                          medium
                          class="icon-table"
                          @click="onShowHeadersDialog"
                        >
                          mdi-table-cog
                        </v-icon>
                      </v-col>
                      <v-col
                        cols="12"
                        class="mt-n5"
                      >
                        <div v-if="filter.set">
                          <div
                            v-for="(tab, index) in filterFields"
                            :key="'tab_f' + index"
                          >
                            <v-chip
                              v-for="(filter, index2) in tab.data.filter(a=>a.value ||a.value ===0 || a.from || a.to || a.max || a.min)"
                              :key="'data_f' + index2"
                              color="grey lighten-2"
                              class="ma-1"
                              close
                              @click:close="onClearFilterValue(filter)"
                            >
                              <span v-if="filter.type == 'date'">{{ filter.name }}: {{ format(filter.from) }}/{{ format(filter.to) }}</span>
                              <span v-else-if="filter.type == 'select' || filter.type == 'autocomplete'">{{ filter.name }}: {{ filter.select.filter(a=>a.value == filter.value)[0].text }}</span>
                              <span v-else>{{ filter.name }}: {{ filter.value }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <!--                    <v-row dense>-->
                    <!--                      <v-col cols="2">-->
                    <!--                        <v-checkbox-->
                    <!--                          v-model="show_deleted_point"-->
                    <!--                          label="Показать удалённые"-->
                    <!--                          @change="onChangeConf"-->
                    <!--                        />-->
                    <!--                      </v-col>-->
                    <!--                    </v-row>-->
                  </v-card-text>
                </v-card>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="100"
                  :nudge-bottom="12"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs, value }">
                    <v-btn
                      v-bind="attrs"
                      color="primary"
                      text
                      v-on="on"
                      @click="sheetitem = item"
                    >
                      <v-icon
                        large
                        class="beg_triangle"
                      >
                        mdi-menu-open
                      </v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list>
                      <v-list-item
                        v-if="!sheetitem.deleted"
                        @click="$router.push('/client/nomenclature/view?id=' + sheetitem.id)"
                      >
                        <v-list-item-content>
                          Открыть
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="!sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="$router.push('/client/nomenclature/change?id=' + sheetitem.id)"
                      >
                        <v-list-item-content>
                          Изменить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="!sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="onDelete(sheetitem)"
                      >
                        <v-list-item-content>
                          Удалить
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="sheetitem.deleted && ($store.state.access[15][3] || $store.state.access[15][4] && sheetitem.creator && sheetitem.creator.id == $store.state.user.id)"
                        @click="onRestore(sheetitem)"
                      >
                        <v-list-item-content>
                          Восстановить
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item.category="{item}">
                <v-chip v-if="item.category">
                  {{ getCategoryText(item.category) }}
                </v-chip>
              </template>
              <template v-slot:item.type="{item}">
                <v-chip v-if="item.type">
                  {{ getNomenclatureTypeText(item.type) }}
                </v-chip>
              </template>
              <template v-slot:item.client="{item}">
                <v-chip v-if="item">
                  {{ getClientText(item.client) }}
                </v-chip>
              </template>
              <template v-slot:item.subcategory="{item}">
                <span v-if="item">
                  {{ getCategoryText(item.subcategory) }}
                </span>
              </template>
              <template v-slot:item.unit="{item}">
                <v-chip v-if="item.unit">
                  {{ getUnitText(item.unit) }}
                </v-chip>
              </template>
              <template v-slot:item.tax="{item}">
                <v-chip v-if="item.tax">
                  {{ getTaxText(item.tax) }}
                </v-chip>
              </template>
              <template v-slot:item.productLabelingType="{item}">
                <span v-if="item">
                  {{ getProductTypeText(item.productLabelingType) }}
                </span>
              </template>
              <template v-slot:item.age18Check="{item}">
                <v-chip v-if="item.age18Check">
                  {{ 'Да' }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <!-- find dialog -->
      <v-dialog
        v-model="showFilterDialog"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-filter-outline"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Фильтры</span>
          </v-card-title>
          <v-card-text>
            <v-tabs
              v-model="tabIndex"
              v-resize="onResizeWindow"
              :vertical="verticalTabs"
            >
              <v-tab
                v-for="(tab, index) in filterFields"
                :key="index"
              >
                <div class="filter_row">
                  {{ tab.name }}
                  <v-btn
                    icon
                    @click="onSetFavouriteTab(tab.index)"
                  >
                    <v-icon
                      left
                      :class="[{'active': $store.state.user.tab_place == tab.index}]"
                    >
                      mdi-star
                    </v-icon>
                  </v-btn>
                </div>
              </v-tab>

              <v-tab-item
                v-for="(tab, index) in filterFields"
                :key="index"
              >
                <v-card flat>
                  <v-card-text>
                    <div
                      v-for="(field, index2) in tab.data"
                      :key="'i_'+index2"
                    >
                      <v-select
                        v-if="field.type=='select'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                      <div
                        v-else-if="field.type=='date'"
                        clearable
                        :label="field.name"
                        :items="field.select"
                      >
                        <v-row>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="field.date_select"
                              clearable
                              :label="field.name"
                              :items="[{value:'yesterday', text:'Вчера'},{value:'today', text:'Сегодня'},{value:'tomorrow', text:'Завтра'},{value:'date', text:'Конкретная дата'},{value:'period', text:'Период дат'}]"
                              @change="onChangeFilterDateType($event, index , field)"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="field.from"
                              :label="field.date_select == 'period' ? 'От' : 'Конкретная дата'"
                              :disabled="field.date_select !== 'period' && field.date_select !== 'date'"
                              type="date"
                              :max="maxDate"
                              @input="filter.changed = true"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-if="field.date_select == 'period'"
                              v-model="field.to"
                              label="До"
                              type="date"
                              :max="maxDate"
                              @input="filter.changed = true"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-text-field
                        v-else-if="field.type==='text'"
                        v-model="field.value"
                        :label="field.name"
                        :type="field.type"
                        @input="filter.changed = true"
                      />
                      <v-autocomplete
                        v-else-if="field.type==='autocomplete'"
                        v-model="field.value"
                        clearable
                        :label="field.name"
                        :items="field.select"
                        @change="filter.changed = true"
                      />
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="showFilterDialog = false, onSetFilter()"
            >
              <span class="mx-10">Применить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="showFilterDialog = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <!-- dialog -->
      <v-dialog
        v-model="dialog.headers.show"
        persistent
        max-width="900px"
      >
        <base-material-card
          color="primary"
          icon="mdi-table-cog"
          inline
          class="filter_popup"
        >
          <v-card-title>
            <span class="text-h5">Настройка столбцов</span>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :items-per-page="5"
              dense
              :items="headers.filter(a=>!a.show)"
              :headers="[{value: 'text', text: 'Название столбца'}, {value: 'active_temp', text: 'Отображение'}]"
              :footer-props="datatable_footer"
              no-data-text="Нет данных для отображения"
            >
              <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
              </template>
              <template v-slot:item.active_temp="{item}">
                <v-checkbox v-model="item.active_temp" />
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              width="80"
              color="primary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-primary"
              @click="dialog.headers.show = false, onSetHeaders()"
            >
              <span class="mx-10">Сохранить</span>
            </v-btn>
            <v-btn
              width="80"
              color="secondary darken-1"
              outlined
              rounded
              small
              class="ml-2 mb-2 btn-hi-secondary"
              @click="dialog.headers.show = false"
            >
              <span class="mx-10">Закрыть</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-dialog>
      <dialog-import
        v-if="importNomenclature.show"
        :items="importNomenclature.items"
        :headers="importNomenclature.headers"
        :title="importNomenclature.title"
        @close="importNomenclature.show=false"
      />
    </v-row>
  </v-container>
</template>
<script>
import $ from 'jquery'
import moment from "moment/moment"
import { JustpayNomenclature } from "@/views/loyalty/shared/services/justpay-nomenclature-service"
import DialogImport from "@/views/loyalty/shared/components/dialog-import/DialogImport.vue"
import { JustpayUser } from "@/views/loyalty/shared/services/justpay-user-service"

export default {
  name: 'NomenclatureList',
  components: { DialogImport },
  data: () => ({
    categories: [],
    clients: [],
    dialog: {
      headers: {
        show: false
      }
    },
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [5, 10, 15, 30, 50],
    },
    filter: {
      set: false
    },
    filterFields: {
      common: {
        index: 0,
        name: "Основное",
        active: true,
        data: [
          {
            name: "Код номенклатуры",
            data: "code",
            type: "text",
          },
          {
            name: "Наименование",
            data: "name",
            type: "text",
          },
          {
            name: "Клиент",
            data: "client",
            type: "autocomplete",
            select: []
          },
          {
            name: "Категория",
            data: "category",
            type: "autocomplete",
            select: []
          },
          {
            name: "Подкатегория",
            data: "subCategory",
            type: "autocomplete",
            select: []
          },
          {
            name: "Тип номенклатуры",
            data: "type",
            type: "autocomplete",
            select: []
          },
          {
            name: "Поставщик",
            data: "supplier",
            type: "autocomplete",
            select: []
          },
          {
            name: "Единица измерения",
            data: "unit",
            type: "select",
            select: []
          },
          {
            name: "НДС",
            data: "tax",
            type: "select",
            select: []
          },
          {
            name: "Тип маркировки",
            data: "product_labeling_type",
            type: "select",
            select: []
          },
          {
            name: "Для 18 +",
            data: "age18check",
            type: "select",
            select: [{ text: 'Нет', value: false }, { text: 'Да', value: true }]
          },

        ]
      }
    },
    form: {},
    headers: [
      {
        text: 'Действия',
        value: 'actions',
        show: true
      },
      {
        text: 'Код номенклатуры',
        value: 'code',
        active: true,
        active_temp: true
      },
      // {
      //   text: 'Номер',
      //   value: 'number',
      //   active: true,
      //   active_temp: true
      // },
      {
        text: 'Наименование',
        value: 'name',
        active: true,
        active_temp: true
      },
      {
        text: 'Клиент',
        value: 'client',
        active: true,
        active_temp: true
      },
      {
        text: 'Описание',
        value: 'description',
        active: true,
        active_temp: true
      },
      {
        text: 'Категория',
        value: 'category',
        active: true,
        active_temp: true
      },
      {
        text: 'Подкатегория',
        value: 'subcategory',
        active: true,
        active_temp: true
      },
      {
        text: 'Тип номенклатуры',
        value: 'type',
        active: true,
        active_temp: true
      },
      {
        text: 'Стоимость',
        value: 'price',
        active: true,
        active_temp: true
      },
      {
        text: 'Единица измерения',
        value: 'unit',
        active: true,
        active_temp: false
      },
      {
        text: 'НДС',
        value: 'tax',
        active: true,
        active_temp: false
      },
      {
        text: 'Остаток',
        value: 'rest',
        active: true,
        active_temp: false
      },
      {
        text: 'На реализации',
        value: 'in_sale',
        active: true,
        active_temp: false
      },
      {
        text: 'Тип маркировки',
        value: 'productLabelingType',
        active: true,
        active_temp: false
      },
      {
        text: 'Для 18+',
        value: 'age18Check',
        active: true,
        active_temp: false
      },
    ],
    items: [],
    importNomenclature: {
      items: [],
      headers: [
        { text: 'Наменование', value: 'name' },
        { text: 'Цена', value: 'price' },
      ],
      show: false,
      title: 'Импортировано'
    },
    justpayNomenclatureService: null,
    justpayUserService: null,
    loading: false,
    nomenclatureTypes: [],
    productTypes: [],
    select: {},
    sheetitem: {},
    showFilterDialog: false,
    showHeaderDialog: false,
    tabIndex: 0,
    table_options: {},
    taxTypes: [],
    total: 0,
    verticalTabs: true,
  }),
  computed: {
    maxDate: function () {
      return moment().format('YYYY-MM-DD')
    },
  },
  watch: {
    table_options: {
      async handler () {
        console.log(this.table_options)
        this.$router.push({
          query: {
            page: this.table_options.page,
            limit: this.table_options.itemsPerPage
          }
        })
        await this.loadAsync()
      },
      deep: true,
    },
  },
  beforeMount () {
    this.justpayNomenclatureService = new JustpayNomenclature()
    this.justpayUserService = new JustpayUser()
  },
  async mounted () {
    await this.loadAsync()
    this.setDefaultHeaders()
  },
  methods: {
    format: function (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    getCategoryText (categoryValue) {
      const found = this.categories.find(f => f.value === categoryValue)
      return found ? found.text : ''
    },
    getClientText (clientValue) {
      const found = this.clients.find(f => f.value === clientValue)
      return found ? found.text : ''
    },
    getNomenclatureTypeText (nomenclatureTypeValue) {
      const found = this.nomenclatureTypes.find(f => f.value === nomenclatureTypeValue)
      return found ? found.text : ''
    },
    getProductTypeText (productTypeValue) {
      const found = this.productTypes.find(f => f.value === productTypeValue)
      return found ? found.text : ''
    },
    getUnitText (unitValue) {
      const dict = this.$store.state.dict.unit_type
      const found = Object.keys(dict).map(x => ({
        value: Number(x),
        text: dict[x].name
      })).find(f => f.value === unitValue)
      return found ? found.text : ''
    },
    getTaxText (taxValue) {
      const found = this.taxTypes.find(f => f.value === taxValue)
      return found ? found.text : ''
    },
    async loadAsync () {
      const request = JSON.parse(JSON.stringify(this.form))
      console.log('request', request)
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filterFields))
        delete request.data.set
        delete request.data.changed
      }
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
      request.page = page
      request.limit = itemsPerPage
      // request.all = this.show_deleted_point
      const response = await this.justpayNomenclatureService.getNomenclatureList(request)
      console.log('response', response)

      if (!response.error) {
        this.items = response.data
        this.total = response.count
        this.categories = response.categories
        this.mainCategories = this.categories.filter(f => f.group == null)
        this.nomenclatureTypes = response.nomenclatureTypes
        this.clients = response.clients
        this.productTypes = response.productTypes
        this.suppliers = response.suppliers
        this.taxTypes = response.taxTypes
      }
      this.filterFields.common.data.map(m=>{
        if (m.data==='client') {
          m.select = this.clients
        }
        if (m.data==='category') {
          m.select = this.mainCategories
        }
        if (m.data==='type') {
          m.select = this.nomenclatureTypes
        }
        if (m.data==='supplier') {
          m.select = this.suppliers
        }
        if (m.data==='unit') {
          const dict = this.$store.state.dict.unit_type
          m.select = Object.keys(dict).map(x => ({
            value: Number(x),
            text: dict[x].name
          }))
        }
        if (m.data==='tax') {
          m.select = this.taxTypes
        }
        if (m.data==='product_labeling_type') {
          m.select = this.productTypes
        }
        return m
      })
      this.loading = false
    },
    onChangeFilterDateType (value, tab, field) {
      this.filter.changed = true
      console.log('changeFilterDateType', value, tab, field)
      if (tab && field && value) {
        if (value !== 'period' && value !== 'date') {
          let date = 0
          if (value == 'today') {
            date = new Date()
          } else if (value == 'yesterday') {
            date = new Date().setDate(new Date().getDate() - 1)
          } else if (value == 'tomorrow') {
            date = new Date().setDate(new Date().getDate() + 1)
          }
          const formated_date = this.formatInputDate(date)
          field.from = formated_date
          field.to = formated_date
        }
        if (value == 'date') {
          field.to = ''
        }
      }
    },
    onClearFilterValue (field) {
      field.value = ''
      field.from = ''
      field.to = ''
      field.date_select = ''
      field.min = ''
      field.max = ''
      this.filter.changed = true
      this.onSetFilter()
    },
    async onDelete (item) {
      if (confirm('Вы уверены?')) {
        item.deleted = true
        // await this.justpaySupplierService.changeSupplier(item)
        this.loading = false
        await this.loadAsync()
      }
    },
    async onImport () {
       this.importNomenclature.items = await this.justpayNomenclatureService.getImport()
      this.importNomenclature.show = true
    },
    async onLoad () {
      await this.loadAsync()
    },
    onReport () {
      const request = JSON.parse(JSON.stringify(this.form))
      if (this.filter.set) {
        request.data = JSON.parse(JSON.stringify(this.filter_fields))
        delete request.data.set
        delete request.data.changed
      }
      request.headers = this.headers.filter(a => a.active == true).map(a => a.value)
      const form = $('<form>', {
        target: '_blank',
        action: '/api/nomenclature/export?token=' + localStorage.getItem("token"),
        method: 'post',
      })
      form.append(
          $('<input>', {
            type: 'hidden',
            value: JSON.stringify(request),
            name: 'form',
          })
      )
      form.appendTo('body').submit()
    },
    onResizeWindow () {
      this.verticalTabs = window.innerWidth > 600
    },
    async onRestore (item) {
      if (confirm('Вы уверены?')) {
        item.deleted = false
        // await this.justpaySupplierService.changeSupplier(item)
        this.loading = false
        await this.loadAsync()
      }
    },
    async onSetFilter () {
      if (this.filter.changed) this.filter.set = true
      this.filter.changed = false
      await this.loadAsync()
      localStorage.setItem(this.entity, JSON.stringify(this.filter_fields))
    },
    async onSetHeaders () {
      await this.justpayUserService.headers('nomenclature', this.headers)
    },
    onSetFavouriteTab (index) {
      this.axios.post('/api/user/favourite_tab', { value: index, type: 'tab_point' })
          .then(result => {
            if (!result.data.error) {
              this.$store.commit('SET_FAVOURITE_TAB', { value: index, type: 'tab_point' })
            }
          })
          .catch(e => {
          })
    },
    async onShowFilterDialog () {
      this.showFilterDialog = true
    },
    onShowHeadersDialog () {
      for (const x in this.headers) {
        this.headers[x].active_temp = this.headers[x].active
      }
      this.dialog.headers.show = true
    },
    setDefaultHeaders () {
      if (!this.$store.state.user.nomenclature_headers || this.$store.state.user.nomenclature_headers.length === 0) return
      this.headers = this.headers.map(header => {
        header.active = this.$store.state.user.nomenclature_headers.indexOf(header.value) > -1
        return header
      })
    },
  }
}
</script>
<style scoped>

</style>
